import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { bookingSectionStyles } from './BookingSection.styles';
import BookingImageGallery from './BookingImageGallery/BookingImageGallery';
import NavigateButton from '../../../../components/NavigateButton/NavigateButton';
import { bookingProperties } from '../../../../constants/bookingProperties';

const BookingSection = () => {
  const [isSectionVisible, setIsSectionVisible] = useState(false);
  const [imagesStartAnimation, setImagesStartAnimation] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsSectionVisible(true);
            // Start image animation after text animation completes (after 1.2s)
            setTimeout(() => {
              setImagesStartAnimation(true);
            }, 1200);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <Box ref={sectionRef} sx={bookingSectionStyles.container}>
      <Box
        sx={{
          ...bookingSectionStyles.textContainer,
          ...bookingSectionStyles.fadeInFromTop(isSectionVisible),
        }}
      >
        <Box sx={bookingSectionStyles.content}>
          <Typography sx={bookingSectionStyles.heading}>Book today</Typography>
          <Typography sx={bookingSectionStyles.title}>Find your next stay</Typography>
          <Typography sx={bookingSectionStyles.subtitle}>
            Royal Vista curates premium residences designed for comfort, elegance, and exceptional stays. We focus on creating refined living experiences by carefully selecting properties that meet high standards of quality, design, and location.
          </Typography>
        </Box>
      </Box>
      <BookingImageGallery 
        imagesStartAnimation={imagesStartAnimation}
        properties={bookingProperties}
      />
      <Box
        sx={{
          ...bookingSectionStyles.buttonContainer,
          ...bookingSectionStyles.fadeInFromTop(isSectionVisible),
        }}
      >
        <NavigateButton title="Book your stay" onClick={() => window.open('https://royal-vista.guestybookings.com/en/properties', '_blank')} isSecondary={false}/>
      </Box>
    </Box>
  );
};

export default BookingSection;
